export default "__VITE_ASSET__DcGm7sT0__"